/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { isMobile } from 'react-device-detect';
import {
  Modal,
  Typography,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Radio,
  SelectionControlLabel,
} from '@one-thd/sui-atomic-components';
import { ContactDetailsFormProps } from '@src/models/lorp';
import { AddressDisplay } from '@src/components/shared/AddressDisplay';

interface LORPAdrressSuggestionModalProps {
  displayModal: boolean;
  onClose: () => void;
  onContinue: (selectedAddress: string) => void;
  formDetails?: ContactDetailsFormProps;
  suggestedAddress?: ContactDetailsFormProps;
}

export const LORPAddressSuggestionModal = ({
  displayModal,
  onClose,
  onContinue,
  formDetails = {},
  suggestedAddress = {},
}: LORPAdrressSuggestionModalProps) => {
  const [selectedAddress, setSelectedAddress] =
    React.useState<string>('suggested');

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedAddress(event.target.value);
  };

  return (
    <Modal open={displayModal} onClose={onClose} className="modal-z-index-fix">
      <ModalHeader
        data-automation-id="addressValidationModalHeader"
        onClose={onClose}
      >
        Verify Your Delivery Address
      </ModalHeader>
      <ModalBody>
        <div className="sui-flex sui-pb-6">
          <Typography
            variant="body-base"
            data-automation-id="addressValidationModalBodyTitle"
          >
            We couldn&apos;t verify your address, but found something similar.
            Please choose one of the following:
          </Typography>
        </div>
        <Typography variant="body-base" weight="bold">
          <label
            htmlFor="originalAddress"
            data-automation-id="originalAddressLabel"
          >
            Original Address
          </label>
          <div className="sui-pt-2 sui-pb-4">
            <SelectionControlLabel
              data-testid="originalAddressText"
              label={<AddressDisplay address={formDetails} />}
            >
              <Radio
                id="originalAddress"
                value="original"
                style={{
                  marginTop: '-4px',
                  alignSelf: 'baseline',
                }}
                data-testid="originalAddressRadio"
                checked={selectedAddress === 'original'}
                onChange={handleRadioChange}
              />
            </SelectionControlLabel>
          </div>
          <label
            htmlFor="suggestedAddress"
            data-automation-id="suggestedAddressLabel"
          >
            Recommended Address
          </label>
          <div className="sui-pt-2 sui-flex sui-pb-6 sui-align-top">
            <SelectionControlLabel
              data-testid="suggestedAddressText"
              label={<AddressDisplay address={suggestedAddress} />}
            >
              <Radio
                id="suggestedAddress"
                value="suggested"
                style={{
                  marginTop: '-4px',
                  alignSelf: 'baseline',
                }}
                data-testid="suggestedAddressRadio"
                checked={selectedAddress === 'suggested'}
                onChange={handleRadioChange}
              />
            </SelectionControlLabel>
          </div>
        </Typography>
      </ModalBody>
      <ModalFooter position="end">
        <div
          className={`sui-flex sui-gap-4 ${
            isMobile ? 'sui-flex-col-reverse sui-w-full' : 'sui-flex-row'
          }`}
        >
          <div>
            <Button
              data-automation-id="addressVerifyCancel"
              variant="secondary"
              onClick={onClose}
            >
              Cancel
            </Button>
          </div>
          <div>
            <Button
              data-automation-id="addressVerifyContinue"
              variant="primary"
              onClick={() => onContinue(selectedAddress)}
            >
              Continue
            </Button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
};
